<p [pTooltip]="fullListOfPeople" tooltipPosition="top">
  {{ truncatedListOfPeople }}
</p>
